import * as Yup from "yup";

const validationSchema = Yup.object().shape({
  route: Yup.string().required("Route is required"),
  driverName: Yup.string().required("Driver Name is required"),
  vehicleNumber: Yup.string().required("Vehicle No. is required"),
  dispatchDate: Yup.date().required("Dispatch Date is required"),
});

export { validationSchema };
